import { useState, useEffect } from "react";

import { getSolutionTitle, getSolution } from "../../../../services/SolutionAPI";

import SolutionCard from "./SolutionCard";
import SolutionContainer from "./SolutionContainer";
import { checkSession } from "../../../../services/Admin";

const Solution = () => {
    const [titleText, setTitleText] = useState(null);
    const [titleImage, setTitleImage] = useState(null);
    const [cardList, setCardList] = useState([]);

    const [isSolutionUpdated, setIsSolutionUpdated] = useState(false);

    useEffect(() => {
        checkSession();
        getSolutionTitle().then((result) => {
            setTitleText(result.name);
            setTitleImage(result.imageUrl);
        });

        updateSolutionCard();
    }, []);

    useEffect(() => {
        getSolutionTitle().then((result) => {
            setIsSolutionUpdated(false);
            setTitleText(result.name);
            setTitleImage(result.imageUrl);
        });
    }, [isSolutionUpdated]);

    useEffect(() => {
        updateSolutionCard();
    }, [isSolutionUpdated]);

    const updateSolutionCard = () => {
        getSolution().then((result) => {
            let cards = [];

            result.map((product, index) => {
                cards.push(
                    <div key={index}>
                        <SolutionCard
                            productID={product["productID"]}
                            image={product["imageURL"]}
                            name={product["name"]}
                            type={product["sortType"]}
                            setIsSolutionUpdated={setIsSolutionUpdated}
                        />
                    </div>
                );
            });

            setCardList(cards);
        });
    };

    return (
        <>
            {titleText !== null && titleImage !== null && (
                <SolutionContainer
                    titleImage={titleImage}
                    titleText={titleText}
                    cardList={cardList}
                    selected_page={4}
                    setIsSolutionUpdated={setIsSolutionUpdated}
                />
            )}
        </>
    );
};

export default Solution;
